import React from 'react'
import moment from 'moment'
import OnboardingTip from './OnboardingTip'
import Resource from '../Resource'
import { BADGE_INFO } from '../Utils'

const sound = new Audio(require('../sounds/reaction.mp3'))

const Emoji = [
  {
    key: 'omg',
    src: require('../images/emoji/omg.png'),
  },
  {
    key: 'shycheer',
    src: require('../images/emoji/shycheer.png'),
  },
  {
    key: 'thumbsup',
    src: require('../images/emoji/thumbsup.png'),
  },
]

class Reactions extends React.Component {
  state = {
    open: false,
  }

  render() {
    const { data, onToggleReaction, myId } = this.props
    const { open } = this.state

    return (
      <div className={`reactions ${open && 'open'}`} tabIndex={-1}>
        <div className="reactions-inner">
          <div className="add-sheet">
            {Emoji.map((e) => (
              <button
                key={e.key}
                className={`button ${(data[e.key] || []).includes(myId) && 'given'}`}
                onClick={() => {
                  onToggleReaction(e.key)
                  this.setState({ open: false })
                }}
              >
                <img src={e.src} alt="icon" />
              </button>
            ))}
          </div>
          {Emoji.filter((e) => (data[e.key] || []).length > 0).map((e) => (
            <button
              className={`button ${(data[e.key] || []).includes(myId) && 'given'}`}
              key={e.key}
              onClick={() => onToggleReaction(e.key)}
            >
              <img src={e.src} alt="icon" /> {data[e.key].length}
            </button>
          ))}
          <div className="add" onClick={() => this.setState({ open: !open })}>
            {open ? 'x' : '+'}
          </div>
        </div>
      </div>
    )
  }
}

const BadgeIcon = ({ type }) => {
  const badge = BADGE_INFO.find((b) => b.key === type.split('badge-').pop())
  if (!badge) return
  return (
    <img
      src={badge.icon}
      style={{ maxWidth: 80, maxHeight: 80, float: 'right', marginRight: -10 }}
      alt="Badge icon"
    />
  )
}

export default class FeedContainer extends React.Component {
  render() {
    const { me } = this.props

    return (
      <div className="screen feed screen-flex-wrapper">
        <div className="navigation-bar">
          <div className="title">Community</div>
        </div>
        <OnboardingTip text="Follow other participants as they complete videos and log exercise!" />
        <div className="screen-scroll-content">
          <Resource collection path={['feed']} placeholder={[]}>
            {(items, { onUpdateItem }) => (
              <div className="feed">
                {items.map((item) => (
                  <div className="feed-entry" key={item.id}>
                    {item.type.startsWith('badge-') && <BadgeIcon type={item.type} />}
                    <h3>{item.user.username}</h3>
                    <div
                      className="body"
                      dangerouslySetInnerHTML={{
                        __html: item.message,
                      }}
                    />
                    <div className="date">{moment(item.createdAt).fromNow()}</div>
                    <Reactions
                      data={item.reactions}
                      myId={me.id}
                      onToggleReaction={(emoji) => {
                        item.reactions[emoji] = item.reactions[emoji] || []
                        if (item.reactions[emoji].includes(me.id)) {
                          item.reactions[emoji] = item.reactions[emoji].filter((i) => i !== me.id)
                        } else {
                          item.reactions[emoji].push(me.id)
                          sound.play()
                        }

                        // give the server a hint to make the backend update easy
                        item.toggleReaction = emoji

                        onUpdateItem(item)
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </Resource>
        </div>
      </div>
    )
  }
}
